import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { FloppyDisk } from "@phosphor-icons/react";

const FIELDS = [
  { key: "raison_sociale", label: "Raison sociale" },
  { key: "forme_juridique", label: "Forme juridique" },
  { key: "capital", label: "Capital social" },
  { key: "siret", label: "SIRET" },
  { key: "rcs", label: "RCS" },
  { key: "tva", label: "N° TVA intracommunautaire" },
  { key: "orias", label: "Immatriculation ORIAS" },
  { key: "adresse", label: "Adresse" },
  { key: "telephone", label: "Téléphone" },
  { key: "email", label: "Email" },
  { key: "directeur_publication", label: "Directeur de la publication" },
  { key: "hebergeur", label: "Hébergeur" },
];

export default function AdminLegal() {
  const [data, setData] = useState({});
  useEffect(() => { api.get("/legal").then((r) => setData(r.data || {})); }, []);

  const save = async () => {
    try {
      const payload = {};
      [...FIELDS.map((f) => f.key), "custom_text"].forEach((k) => { payload[k] = data[k] || ""; });
      await api.put("/legal", payload);
      toast.success("Mentions légales enregistrées");
    } catch (err) { toast.error(formatApiError(err)); }
  };

  const inputCls = "w-full bg-ducs-night border border-ducs-gold/25 px-3 py-2 text-ducs-cream rounded-sm text-sm focus:border-ducs-gold";

  return (
    <div data-testid="admin-legal" className="p-8 md:p-10">
      <div className="label-caps mb-3">Mentions légales</div>
      <h1 className="font-serif text-3xl md:text-4xl text-ducs-cream">Informations juridiques</h1>
      <p className="text-ducs-mist mt-2 max-w-2xl">Complétez les informations légales du cabinet. Elles s'affichent automatiquement sur la page publique.</p>

      <div className="mt-10 card-ducs p-6 grid sm:grid-cols-2 gap-4">
        {FIELDS.map((f) => (
          <div key={f.key}>
            <label className="label-caps block mb-2">{f.label}</label>
            <input
              className={inputCls}
              value={data[f.key] || ""}
              onChange={(e) => setData({ ...data, [f.key]: e.target.value })}
              data-testid={`legal-${f.key}`}
            />
          </div>
        ))}
        <div className="sm:col-span-2">
          <label className="label-caps block mb-2">Texte complémentaire</label>
          <textarea
            className={inputCls}
            rows={5}
            value={data.custom_text || ""}
            onChange={(e) => setData({ ...data, custom_text: e.target.value })}
            data-testid="legal-custom-text"
          />
        </div>
      </div>

      <button onClick={save} className="btn-primary mt-6" data-testid="legal-save">
        <FloppyDisk size={16} /> Enregistrer
      </button>
    </div>
  );
}
